/**
 * referralIcons.js — SVG-иконки только для реферальной модалки.
 *
 * GiftOutlineIcon  — подарок в заголовке «Как это работает»
 * ShareIcon        — шаг 1 (код / регистрация)
 * CardIcon         — шаг 2 (пробный период → оплата)
 * CopyIcon         — кнопка «Скопировать»
 * CheckIcon        — состояние «Скопировано»
 * CloseIcon        — крестик закрытия модалки
 */

import { color_red_default, color_white } from "../../../constants/colors";

export function GiftOutlineIcon({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M20 12v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8M3 8h18v4H3V8Zm9 0v13M12 8c0-2.2 1.2-4 2.8-4 1.2 0 2.2 1.4 2.2 3.2C17 8.6 14.4 8 12 8Zm0 0C12 5.8 10.8 4 9.2 4 8 4 7 5.4 7 7.2 7 8.6 9.6 8 12 8Z"
        stroke={color_red_default}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ShareIcon({ size = 22 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="18" cy="5" r="3" stroke={color_red_default} strokeWidth="1.7" />
      <circle cx="6" cy="12" r="3" stroke={color_red_default} strokeWidth="1.7" />
      <circle cx="18" cy="19" r="3" stroke={color_red_default} strokeWidth="1.7" />
      <path
        d="M8.6 10.7 15.4 6.3M8.6 13.3l6.8 4.4"
        stroke={color_red_default}
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function CardIcon({ size = 22 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect
        x="3"
        y="6"
        width="18"
        height="12"
        rx="2"
        stroke={color_red_default}
        strokeWidth="1.7"
      />
      <path d="M3 10h18" stroke={color_red_default} strokeWidth="1.7" />
      <path
        d="M7 15h4"
        stroke={color_red_default}
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function CopyIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <rect x="8" y="8" width="12" height="12" rx="2" stroke={color_white} strokeWidth="1.8" />
      <path
        d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"
        stroke={color_white}
        strokeWidth="1.8"
      />
    </svg>
  );
}

export function CheckIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 13l4 4L19 7"
        stroke={color_white}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path
        d="M6 6l12 12M18 6 6 18"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
